import type { Class } from '../types.js'
import { Block } from './block.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { ScreenEditorInput } from './decorators/screen-editor-input.js'

export abstract class LeafBlock extends Block {
	readonly allowedChildTypes: '*' | Class<Block>[] = []
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'input',
		order: 21,
		label: 'Example text',
		contentType: 'text',
		elementType: 'input',
	})
	exampleText: string = ''

	canHaveChildren(): boolean {
		return false
	}

	canHaveChild(child: Block): boolean {
		return false
	}

	canHaveParent(parent: Block | undefined): boolean {
		return true
	}
}
